var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({staticClass:"TimeUnitSourceIcon"},on),[_c('v-icon',{class:_vm.icon.class,attrs:{"right":"","size":"14"}},[_vm._v(" "+_vm._s(_vm.icon.name)+" ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(`Imported from ${_vm.sourceName}`)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }